<template>
  <div class="pages-hierarchy-loading">
    <span style="width: 70%" />
    <span style="width: 50%" />
    <span style="width: 50%" />
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "PagesHierarchyLoading",
});
</script>
<style scoped lang="scss">
.pages-hierarchy-loading {
  margin-top: 16px;
  margin-inline-start: 16px;

  span {
    position: relative;
    overflow: hidden;
    display: block;
    height: 8px;
    border-radius: 2px;
    width: 70%;
    margin-bottom: 16px;
    @include themed() {
      background: t($grey-15);
    }

    &::after {
      position: absolute;
      top: 0;
      inset-inline-end: 0;
      bottom: 0;
      inset-inline-start: 0;
      transform: translateX(-100%);
      background-image: linear-gradient(
        90deg,
        rgba(#fff, 0) 0,
        rgba(#fff, 0.2) 20%,
        rgba(#fff, 0.5) 60%,
        rgba(#fff, 0)
      );
      animation: shimmer 5s infinite;
      content: "";
    }

    @keyframes shimmer {
      100% {
        transform: translateX(100%);
      }
    }
  }
}
</style>
